import React, { ReactElement } from "react"
import { DownloadOutlined } from "@ant-design/icons"
import { Image, Button, Modal } from "antd"
import { createPortal } from "react-dom"

interface IProps {
  src: string
  type: boolean
  visible: boolean
  onClose: () => void
}

const ImagePreview = ({
  src,
  type,
  visible,
  onClose,
}: IProps): ReactElement => {

  return (
    <>
      {/* 这里的 Image 组件仅用于承载预览逻辑，width={0} 隐藏其占位 */}
      {type ? (
        <Image
          width={0}
          src={src}
          preview={{
            visible: visible,
            onVisibleChange: (value) => {
              if (!value) {
                onClose()
              }
            },
          }}
        />
      ) : (
        <Modal
          width={800}
          footer={null}
          title=""
          visible={visible}
          onOk={() => {
            onClose()
          }}
          onCancel={() => {
            onClose()
          }}
        >
          <div
            style={{
              maxHeight: "600px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: "40px",
            }}
          >
            <span style={{ fontSize: "16px" }}>该文件类型暂不支持预览</span>
            <a
              style={{ marginTop: "20px" }}
              onClick={(v) => {
                if (src.indexOf("hydhis.c") >= 0) {
                  window.open(src.replace("http:", "https:"), "_blank")
                } else {
                  window.open(src, "_blank")
                }
              }}
            >
              下载
            </a>
          </div>
        </Modal>
      )}
      {/* Portal 挂载下载按钮 */}
      {visible && type &&
        createPortal(
          <div
            style={{
              position: "fixed",
              bottom: 100,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10001,
            }}
          >
            <Button
              type="primary"
              shape="circle"
              icon={<DownloadOutlined />}
              size="large"
              style={{ backgroundColor: 'transparent', borderColor: '#fff' }}
              onClick={(v) => {
                if (src.indexOf("hydhis.c") >= 0) {
                  window.open(src.replace('http:', 'https:'), '_blank')
                } else {
                  window.open(src, '_blank')
                }
              }}
            />
          </div>,
          document.body,
        )}
    </>
  )
}

export default ImagePreview
